import { FormValues } from '../CreateNewAffordabilityForm/CreateNewAffordabilityForm.types';
import { CreateCalculationPayload, CreateCalculationResponse } from '../../../api/types';
import { CreatedCalculation } from '../Listing.types';

const createCalcPayload = (formValues: FormValues): CreateCalculationPayload => {
  return {
    name: formValues.name,
    related_case_number: formValues.caseNumber,
  };
};

export const mapCreateResponse = (createResponse: CreateCalculationResponse): CreatedCalculation => {
  return {
    calculationId: createResponse.calculationId,
  };
};

export default createCalcPayload;
